module.exports = __webpack_public_path__ + "img/deyu_bigtitle_bg.69063cac.png";